import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Link, Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Contact from './Contact';
import { contactsRef, usersRef, childrenRef, auth } from '../../firebase';
import ContactSelect from './ContactSelect';

const styles = theme => ({
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    }
});

class Contacts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            inviteRequests: []
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = () => {
        this.setState({
            loading: true
        })

        contactsRef.where('refId', '==', this.props.myId).get()
            .then((querySnapshot) => {
                let data = [];
                let emailIds = [];

                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    let contactData = {
                        id: doc.id,
                        contact: doc.data(),
                    }

                    emailIds.push(doc.data().email);
                    data.push(contactData);
                });

                this.setState({
                    data
                })

                let promises = [];

                emailIds.forEach(email => {
                    promises.push(usersRef.where('email', '==', email).get())
                });


                Promise.all(promises)
                    .then(res => {
                        let userIds = [];
                        res.forEach(user => {
                            if (user.size == 0) {
                                userIds.push('')
                            }
                            user.forEach(u => {
                                userIds.push(u.id)
                            })
                        })

                        let childDataPromises = []

                        userIds.forEach(user => {
                            childDataPromises.push(childrenRef.where('parentId', '==', user).get())
                        })

                        Promise.all(childDataPromises)
                            .then(childSnapshots => {
                                const { data } = this.state
                                let finalData = []
                                childSnapshots.forEach((each, index) => {
                                    let children = []
                                    each.forEach(doc => {
                                        let child = doc.data()
                                        children.push(
                                            child.firstName + ' ' + child.lastName
                                        )
                                    })


                                    finalData.push({
                                        id: data[index].id,
                                        contact: data[index].contact,
                                        children
                                    })
                                })

                                console.log('FINAL', finalData)

                                this.setState({
                                    data: finalData,
                                    displayData: finalData,
                                    loading: false,
                                })
                            })
                    })
            });

        contactsRef.where('email', '==', auth.currentUser.email).where('pending', '==', true).get()
            .then(querySnap => {
                let requests = []

                querySnap.forEach(doc => {
                    requests.push({
                        id: doc.id,
                        refId: doc.data().refId,
                    })
                })


                this.setState({
                    requests
                })

                let promises = []
                requests.forEach(id => {
                    promises.push(usersRef.doc(id.refId).get())
                })

                Promise.all(promises)
                    .then(res => {
                    const { requests } = this.state
                    let finalData = []

                    for(let i = 0; i < res.length; i++) {
                        let id = requests[i]
                        finalData.push({
                            id: id.id,
                            name: res[i].data().firstName + ' ' + res[i].data().lastName
                        })
                    }

                    console.log('REQUETS: ' + JSON.stringify(finalData))


                    this.setState({
                        inviteRequests: finalData
                    })
                })
            })

        this.state = {
            data: [],
            displayData: [],
            loading: true,
        }
    }

    searchFilter = text => {
        let searchTerm = text.target.value

        const { data } = this.state;

        let displayData = [];

        data.forEach(value => {
            let name = value.contact.firstName + ' ' + value.contact.lastName;


            if (name.toLocaleLowerCase().startsWith(searchTerm.toLocaleLowerCase())) {
                displayData.push(value);
            }
        });

        this.setState({ displayData });
    }

    setStatus = (id, status) => {
        if(status === false) {
            contactsRef.doc(id).delete().then(() => {
                this.fetchData()
            })
        } else {
            contactsRef.doc(id).update({
                'accepted': status,
                'pending': false,
            }).then(() => {
                this.fetchData()
            })
        }
    }

    

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        if (this.state.redirect) {
            return(
                <Redirect to='/contacts/' />
            )
        }

        if (this.state.data.length === 0) {
            return (
                <div className={classes.title}>
                    <h2>No contacts added yet</h2>
                    <Link to="/contacts/add" style={{ textDecoration: 'none' }}>
                        <Button variant="outlined">+ ADD NEW CONTACT</Button>
                    </Link>
                </div>
            );
        }

        return (
            <div className={classes.title}>
                <Grid container spacing={24}>
                    {this.state.inviteRequests.map((value) => {
                        return (<ContactSelect select={this.setStatus} name={value.name} id={value.id} />)
                    })}
                </Grid>
                <h1>CONTACTS</h1>
                <div>
                    <TextField
                        value={this.state.searchText}
                        onChange={this.searchFilter}
                        style={{ paddingBottom: '30px', width: '80%' }}
                        label="Search"
                    />
                </div>
                <Grid container spacing={24}>
                    {this.state.displayData.map((value) => {
                        return (<Contact children={value.children} contact={value.contact} id={value.id} />)
                    })}
                </Grid>
                <Link to="/contacts/add" style={{ textDecoration: 'none' }}>
                    <Button variant="outlined">+ ADD NEW CONTACT</Button>
                </Link>
            </div>
        );
    }
}

Contacts.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contacts);



// WEBPACK FOOTER //
// ./src/components/Contacts/Contacts.js